import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import style from './lifecycle-banner.module.less';
import getIsActive from '../../../../../components/data-driven-logo/get-is-active';
import getIsBeta from '../../../../../components/data-driven-logo/get-is-beta';
import GetMarketplaceDisplayName from '../../../../../components/data-driven-logo/get-marketplace-display-name';

const LifecycleBanner = ({ marketplaceId = '-1' }) => {
  const intl = useIntl();
  const intMarketplaceId = Number.parseInt(marketplaceId, 10);
  const isBeta = getIsBeta({ marketplaceId: intMarketplaceId });
  const isActive = getIsActive({ marketplaceId: intMarketplaceId });
  const displayName = GetMarketplaceDisplayName(intMarketplaceId) || {};
  const name = intl.formatMessage(displayName, displayName.values);
  if (!isActive) {
    return (
      <BannerMessageV2
        className={style['lifecycle-banner']}
        content={
          <FormattedMessage
            defaultMessage='{name} is no longer supported. To hide this store, mark the store as inactive.'
            description='discontinued lifecycle banner'
            id='KEU90U'
            values={{ name }}
          />
        }
        status={BannerStatus.Error}
      />
    );
  }
  if (isBeta) {
    return (
      <BannerMessageV2
        className={style['lifecycle-banner']}
        content={
          <FormattedMessage
            defaultMessage='{name} is currently in a beta test phase and you may experience unexpected behavior'
            description='beta lifecycle banner'
            id='s0Zf7W'
            values={{ name }}
          />
        }
        status={BannerStatus.Info}
      />
    );
  }

  return null;
};

LifecycleBanner.propTypes = {
  marketplaceId: PropTypes.string,
};

export default LifecycleBanner;
